import { useQuery, UseQueryResult } from '@tanstack/react-query';

import getConsultantDiscoveryData from '@/actions/zee/getZeeDiscoveryData';
import { DiscoveryApiResponse } from '@/types/discovery.type';
import { ApiResponse } from '@/types/response.type';

export interface UseGetConsultantDiscoveryDataParams {
  page?: number;
  limit?: number;
}

export interface UseGetConsultantDiscoveryDataProps {
  result: ApiResponse<DiscoveryApiResponse> | undefined;
  error: Error | null;
  isError: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  isRefetching: boolean;
}

export const useGetConsultantDiscoveryData = (
  params: UseGetConsultantDiscoveryDataParams = {}
): UseGetConsultantDiscoveryDataProps => {
  const { page = 1, limit = 20 } = params;

  const query: UseQueryResult<
    ApiResponse<DiscoveryApiResponse>,
    Error
  > = useQuery({
    queryKey: ['consultant-discovery-data', page, limit],
    queryFn: () => getConsultantDiscoveryData({ page, limit }),
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
